import { Shadow, SkeletonTypes, HStack, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

export const CardLoadingItemMobile: React.FC = () => {
  const ColoredSkeleton = (props: SkeletonTypes.Props) => (
    <Skeleton {...props} endColor="brand.primary.lightest" />
  );

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy} p={Spacing['inset.sm']}>
      <VStack space={Spacing['stack.xxxs']}>
        <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
        </HStack>

        <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
        </HStack>

        <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
        </HStack>

        <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
        </HStack>

        <HStack justifyContent="space-between" py={Spacing['stack.nano']} alignItems="center">
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
          <ColoredSkeleton width="30%" height="15px" rounded="full" />
        </HStack>
      </VStack>
    </Shadow>
  );
};
